import axios from "axios";

// Live RideStamp Fleet API (shared backend used by the mobile app).
export const FLEET_API = process.env.REACT_APP_FLEET_API_BASE;
export const FLEET_TOKEN_KEY = "rs_fleet_token";

const fleetApi = axios.create({ baseURL: FLEET_API });

fleetApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(FLEET_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

fleetApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) localStorage.removeItem(FLEET_TOKEN_KEY);
    return Promise.reject(err);
  }
);

export default fleetApi;

// Coerce any API error (incl. FastAPI 422 detail arrays) into a safe display string.
export function fleetError(err, fallback = "Something went wrong.") {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || (typeof x === "string" ? x : JSON.stringify(x))).join("; ");
  if (typeof d === "string") return d;
  if (d && typeof d === "object") return d.msg || JSON.stringify(d);
  return err?.message || fallback;
}
